<template>
  <v-dialog v-model="dialog" max-width="40%">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" small>
        <v-icon small color="primary">fas fa-cut</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Split {{ instance.forgeID }}?
      </v-card-title>
      <v-card-text>
        This will create a child Batch from {{ instance.name }}.
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="orange darken-2" dark @click="dialog = false">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn color="green darken-1" dark @click.native="splitBatch()">
          <v-icon left>check</v-icon>
          Split
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BatchSplitter",
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  data() {
    return { dialog: false };
  },
  methods: {
    splitBatch() {
      this.instance.split = true;
      this.instance.parent_id = this.instance.id;
      this.instance.constructor.$post(this.instance.toCreatePayload());
      this.dialog = false;
    }
  }
};
</script>
